﻿import React from "react";
import {
  Typography,
  TextField,
  Grid,
  Container,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  selectEditCatalogData,
  selectIsEditMode,
  setCatalogDataField,
} from "@/features/connections/manageCatalogDataSlice";
import {
  defaultCode,
  blankCode,
} from "@/features/connections/integrationSlice";
import { AddEditCatalogPopup } from "./CatalogPopup";

const AddCarrierPopup = ({ onClose, onValidate, onComplete }) => {
  const dispatch = useDispatch();
  const dataValues = useSelector(selectEditCatalogData);
  const isEdit = useSelector(selectIsEditMode);

  const validateForm = () => {
    if (onValidate) {
      const result = onValidate(dataValues);
      if (!result.isValid) return result;
    }
    if (dataValues.CarrierCode === defaultCode) {
      return {
        isValid: false,
        message: `Carrier Code cannot be saved as ${defaultCode}`,
      };
    }
    if (dataValues.CarrierCode === blankCode) {
      return {
        isValid: false,
        message: `Carrier Code cannot be saved as ${blankCode}`,
      };
    }
    if (dataValues.CarrierCode?.includes(",")) {
      return {
        isValid: false,
        message: `The Carrier Code cannot include a ','`,
      };
    }
    return { isValid: true };
  };

  const handleClose = () => {
    onClose();
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    dispatch(setCatalogDataField({ name, value }));
  };

  return (
    <AddEditCatalogPopup
      onClose={handleClose}
      onValidate={validateForm}
      onComplete={onComplete}
    >
      <Grid item xs={4}>
        <Typography>Carrier Code </Typography>
        <TextField
          disabled={isEdit}
          variant="outlined"
          name="CarrierCode"
          value={dataValues?.CarrierCode || ""}
          onChange={handleChange}
          sx={{
            width: 250,
            marginTop: 1,
            marginBottom: 2,
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <Typography>Carrier Name</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="CarrierName"
            value={dataValues?.CarrierName || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>SCAC</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="EDICarrierCode"
            value={dataValues?.EDICarrierCode || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Routing</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="Routing"
            value={dataValues?.Routing || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Service Level</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="ServiceLevel"
            value={dataValues?.ServiceLevel || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Transportation Method Type</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="TransportationMethod"
            value={dataValues?.TransportationMethod || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Billing Account Number</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillingAccountNumber"
            value={dataValues?.BillingAccountNumber || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
    </AddEditCatalogPopup>
  );
};

export default AddCarrierPopup;
